module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-layout"
  }, [_c('div', {
    staticClass: "alert alert-success"
  }, [_c('span', [_vm._v("原取藥數量: " + _vm._s(Math.abs(_vm.currentEvent.number1)))])]), (_vm.currentProgress === 'setStorage') ? _c('ConfirmStorage', {
    attrs: {
      "inputLabel": '設定拋棄藥物數量',
      "defaultAmount": Math.abs(_vm.currentEvent.number1)
    },
    on: {
      "setNum": _vm.getStorage
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3797308e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WasteFlow/ConfirmFlow.vue
// module id = 1430
// module chunks = 1